import React from 'react'
import PropTypes from 'prop-types'
import { TableCell, TableHead, TableRow, TableSortLabel } from '@material-ui/core'

// titulos de columnas
const headCells = [
  { id: 'brand_name', numeric: false, disablePadding: true, label: 'Productores', name: true },
  { id: 'business_name', numeric: false, disablePadding: false, label: 'Razón social' },
  { id: 'rut', numeric: false, disablePadding: false, label: 'RUT' },
  { id: 'min_purchase', numeric: false, disablePadding: true, label: 'Mínimo de venta' },
  { id: 'isActive', numeric: false, disablePadding: false, label: 'Estado' },
  { id: 'actions', numeric: false, disablePadding: false, label: 'Acciones', edit: true },
]

export const EnhancedTableHead = ({ classes, order, orderBy, onRequestSort }) => {
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property)
  }

  return (
    <TableHead>
      <TableRow>
        <TableCell padding="checkbox"></TableCell>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? 'right' : headCell.name ? 'left' : 'center'}
            padding={headCell.disablePadding ? 'none' : 'normal'}
            sortDirection={orderBy === headCell.id ? order : false}>
            <b>
              {!['download', 'actions'].includes(headCell.id) ? (
                <TableSortLabel
                  active={orderBy === headCell.id}
                  direction={orderBy === headCell.id ? order : 'asc'}
                  onClick={createSortHandler(headCell.id)}>
                  {headCell.label}
                  {orderBy === headCell.id ? (
                    <span className={classes.visuallyHidden}>
                      {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                    </span>
                  ) : null}
                </TableSortLabel>
              ) : (
                <span aling="right">{headCell.label}</span>
              )}
            </b>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  )
}

EnhancedTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
}
